import { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useDOMElement } from 'src/lib/domUtils';

import { useSpotlightFloating } from './useSpotlightFloating';
import { useStyles } from './useStyles';

const Spotlight = ({ className, rootElement, target, options }) => {
  const styles = useStyles({ type: options.type });

  const [floatingElement, setFloatingElement] = useState(null);
  const targetElement = useDOMElement(rootElement, target);

  const { floatingStyles, isPositioned } = useSpotlightFloating({
    referenceElement: targetElement,
    floatingElement,
    options,
  });

  if (!targetElement) {
    return null;
  }

  return (
    <div
      className={cx(styles.root, className, { [styles.hidden]: !isPositioned })}
      ref={setFloatingElement}
      style={floatingStyles}
    />
  );
};

Spotlight.propTypes = {
  className: PropTypes.string,
  rootElement: PropTypes.instanceOf(Element),
  target: PropTypes.string.isRequired,
  options: PropTypes.shape().isRequired,
};

const defaultProps = {
  className: null,
  rootElement: null,
};
Spotlight.defaultProps = defaultProps;

export default Spotlight;
